import { PaginationComponentProps } from 'react-data-table-component';
import { TablePagination as MuiTablePagination } from '@mui/material';
import { hideUnavailablePageArrows } from './tablePaginationSx';

export const TablePagination: React.FC<PaginationComponentProps> = ({
  rowsPerPage,
  rowCount,
  currentPage,
  onChangePage,
  onChangeRowsPerPage
}) => {
  return (
    <MuiTablePagination
      component="div"
      labelRowsPerPage="Results per page"
      sx={hideUnavailablePageArrows}
      count={rowCount}
      page={currentPage - 1}
      rowsPerPage={rowsPerPage}
      onPageChange={(event, page) => {
        onChangePage(page + 1, rowCount);
      }}
      onRowsPerPageChange={(event) => {
        onChangeRowsPerPage(Number(event.target.value), currentPage);
      }}
    />
  );
};
